import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmployerRoutingModule } from './employer-routing.module';
import { EmployerComponent } from './employer.component';
import { EmployerProfileComponent } from './employer-profile/employer-profile.component';
import { ValidationErrorComponent } from '../shared/validation-error/validation-error/validation-error.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { CandidateListComponent } from './candidate-list/candidate-list.component';
import { CandidateDetailComponent } from './candidate-detail/candidate-detail.component';
import { AssignedCandidatesListComponent } from './assigned-candidates-list/assigned-candidates-list.component';
import { AssignedCandidateDetailComponent } from './assigned-candidate-detail/assigned-candidate-detail.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';


@NgModule({
  declarations: [
    EmployerComponent,
    EmployerProfileComponent,
    CandidateListComponent,
    CandidateDetailComponent,
    AssignedCandidatesListComponent,
    AssignedCandidateDetailComponent,
    ResetPasswordComponent
  ],
  imports: [
    CommonModule,
    EmployerRoutingModule,
    ValidationErrorComponent,
    ReactiveFormsModule,
    FormsModule,
    SelectDropDownModule
  ]
})
export class EmployerModule { }
